/* angular:styles/component:css;e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855;C:\Users\myElectrical240822\source\repos\myElectrical\mceMainApp\src\app\account\balance\balance.component.ts */
/*# sourceMappingURL=balance.component-5X35KOGN.css.map */
